import React from 'react'
import { makeStyles } from '@material-ui/core'
import { FONT_WEIGHTS } from '../../../utils'

const useStyles = makeStyles(() => ({
	root: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center'
	},
	title: { fontFamily: 'Nunito', fontSize: '1.25rem', fontWeight: FONT_WEIGHTS.SemiBold, paddingTop: '2rem' },
	subtext: {
		fontFamily: 'Nunito',
		fontSize: '0.875rem',
		marginTop: '0.5rem',
		textAlign: 'center',
		width: '70%'
	},
	bottomText: { fontFamily: 'Nunito', fontSize: '0.875rem' },
	childrenContainer: {
		margin: '2rem 0 1rem 0',
		// justifyContent: 'center',
		alignItems: 'center',
		width: '100%',
		flex: 1,
		display: 'flex',
		flexDirection: 'column'
	}
}))

const SectionFormContainer = ({
	title = '',
	subtext = '',
	children,
	titleStyles = {},
	childrenContainerStyles = {}
}) => {
	const classes = useStyles()
	return (
		<div className={classes.root}>
			{title > '' ? (
				<div className={classes.title} style={{ ...titleStyles }}>
					{title}
				</div>
			) : null}
			{subtext > '' ? <div className={classes.subtext}>{subtext}</div> : null}
			<div className={classes.childrenContainer} style={{ ...childrenContainerStyles }}>
				{children}
			</div>
		</div>
	)
}

export default SectionFormContainer
